import React from "react";
import { Field, formValueSelector } from "redux-form";
import { connect } from "react-redux";

import SelectDropdown from "../../../system/fields/SelectDropdown";
import Repeater from "../../../system/fields/Repeater";

import DestinationLegs from "./DestinationLegs";
import TravelLegs from "./TravelLegs";
import GuideLegs from './GuideLegs';

import * as validations from "../../../system/utils/Validation";

const selector = formValueSelector("DealForm");

class Legs extends React.Component {
  constructor(props, leg, index, fields, legType) {
    super(props);
  }

  remove(index) {
    const result = window.confirm("Are you sure you want to remove this row?");
    if (result) {
      this.props.fields.remove(index);
    }
  }

  render() {
    const index = this.props.index;
    const leg = this.props.leg;
    const legs = this.props.legs;
    const fields = this.props.fields;
    console.log("LEG");
    console.log(leg);
    return (
      <Repeater key={index}>
        <div className="toolbar">
          <span className={"toolbar-order"}>
          {this.props.legType !== "" &&
            this.props.legType.name === "Travel" ?
                `Travel Leg ${legs.filter(item =>
                  item.leg_type.name === "Travel")
                  .findIndex(item => {
                    return item.leg_detail !== undefined
                    && item.leg_detail !== null
                    && item.leg_detail !== ''
                      && legs[index].leg_detail !== undefined
                      && legs[index].leg_detail !== ''
                      && legs[index].leg_detail !== null
                      ? item.leg_detail.name === legs[index].leg_detail.name :
                      false
                  }) !== -1 ? legs.filter(item =>
                  item.leg_type.name === "Travel")
                  .findIndex(item => {
                    return item.leg_detail !== undefined
                    && item.leg_detail !== null
                    && item.leg_detail !== ''
                    && legs[index].leg_detail !== undefined
                    && legs[index].leg_detail !== ''
                    && legs[index].leg_detail !== null
                      ? item.leg_detail.name === legs[index].leg_detail.name :
                      false
                  }) + 1 : '' }` :
            this.props.legType.name === "Destination" ?
            `Destination Leg ${legs.filter(item =>
              item.leg_type.name === "Destination")
              .findIndex(item => {
                return item.leg_detail !== undefined
                && item.leg_detail !== null
                && item.leg_detail !== ''
                && legs[index].leg_detail !== undefined
                && legs[index].leg_detail !== ''
                && legs[index].leg_detail !== null
                  ? item.leg_detail.day_from_to === legs[index].leg_detail.day_from_to :
                  false
              }) !== -1 ? legs.filter(item =>
              item.leg_type.name === "Destination")
              .findIndex(item => {
                return item.leg_detail !== undefined
                && item.leg_detail !== null
                && item.leg_detail !== ''
                && legs[index].leg_detail !== undefined
                && legs[index].leg_detail !== ''
                && legs[index].leg_detail !== null
                  ? item.leg_detail.day_from_to === legs[index].leg_detail.day_from_to :
                  false
              }) + 1 : '' }` :
            this.props.legType.name === "Guide" ?
            `Guide Leg ${legs.filter(item =>
            item.leg_type.name === "Guide")
            .findIndex(item => {
              return item.leg_detail !== undefined
              && item.leg_detail !== null
              && item.leg_detail !== ''
              && legs[index].leg_detail !== undefined
              && legs[index].leg_detail !== ''
              && legs[index].leg_detail !== null
                ? item.leg_detail.day_from_to === legs[index].leg_detail.day_from_to :
                false
            }) !== -1 ? legs.filter(item =>
            item.leg_type.name === "Guide")
            .findIndex(item => {
              return item.leg_detail !== undefined
              && item.leg_detail !== null
              && item.leg_detail !== ''
              && legs[index].leg_detail !== undefined
              && legs[index].leg_detail !== ''
              && legs[index].leg_detail !== null
                ? item.leg_detail.day_from_to === legs[index].leg_detail.day_from_to :
                false
            }) + 1 : '' }` :
              this.props.legType.name === "Destination With Tour" &&
                `Destination With Tour Leg ${legs.filter(item =>
                  item.leg_type.name === "Destination With Tour")
                  .findIndex(item => {
                    return item.leg_detail !== undefined
                    && item.leg_detail !== null
                    && item.leg_detail !== ''
                    && legs[index].leg_detail !== undefined
                    && legs[index].leg_detail !== ''
                    && legs[index].leg_detail !== null
                      ? item.leg_detail.day_from_to === legs[index].leg_detail.day_from_to :
                      false
                  }) !== -1 ? legs.filter(item =>
                  item.leg_type.name === "Destination With Tour")
                  .findIndex(item => {
                    return item.leg_detail !== undefined
                    && item.leg_detail !== null
                    && item.leg_detail !== ''
                    && legs[index].leg_detail !== undefined
                    && legs[index].leg_detail !== ''
                    && legs[index].leg_detail !== null
                      ? item.leg_detail.day_from_to === legs[index].leg_detail.day_from_to :
                      false
                  }) + 1 : '' }`}
              
          </span>
          <span className={"group-wrapper"}>
          {this.props.index + 1 !== this.props.fields.length ||
          this.props.index !== 0 ? (
            <div className="group">
              <span>Move</span>
              {this.props.index + 1 !== this.props.fields.length && (
                <i
                  className="fas fa-angle-down"
                  onClick={() => this.props.fields.move(index, index + 1)}
                />
              )}
              {this.props.index !== 0 && (
                <i
                  className="fas fa-angle-up"
                  onClick={() => this.props.fields.move(index, index - 1)}
                />
              )}
            </div>
          ) : (
            ""
          )}
          <i className="far fa-trash-alt" onClick={() => this.remove(index)} />
          </span>
        </div>

        {this.props.legType === "" && (
          <div className="top-field">
            <Field
              name={`${leg}.leg_type`}
              type="text"
              component={SelectDropdown}
              options={[
                { name: "Destination", value: "Destination" },
                { name: "Travel", value: "Travel" },
                { name: "Guide", value: "Guide"},
                { name: "Destination With Tour", value: "Destination With Tour"}
              ]}
              valueKey="value"
              labelKey="name"
              placeholder="Choose a leg type"
            />
          </div>
        )}
        
        {this.props.legType.name === "Guide" && (
          <GuideLegs
            leg={leg}
            fields={fields}
            index={index}
            key={index}
          />
        )}
        {this.props.legType.name === "Destination" && (
          <DestinationLegs
            leg={leg}
            fields={fields}
            index={index}
            key={index}
          />
        )}
        {this.props.legType.name === "Travel" && (
          <TravelLegs
            leg={leg}
            fields={fields}
            index={index}
            key={index}
          />
        )}
        {this.props.legType.name === 'Destination With Tour' && (
          <GuideLegs
            leg={leg}
            fields={fields}
            index={index}
            key={index}
            hotel
          />
        )}
      </Repeater>
    );
  }
}

const LegsWrapper = connect((state, props) => ({
  legType: selector(state, `${props.leg}.leg_type`),
  legs: selector(state, 'legs')
}))(Legs);

export default LegsWrapper;



// WEBPACK FOOTER //
// ./src/containers/Deals/components/Legs.jsx